import { useState, useEffect } from "react";
import { Send, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import api from "@/lib/api";

export const ShareRecordingDialog = ({ rec, onDone }) => {
  const [open, setOpen] = useState(false);
  const [people, setPeople] = useState([]);
  const [pick, setPick] = useState([]);
  const [q, setQ] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) api.get("/api/admin/users").then(r => setPeople(r.data.filter(u => u.role !== "admin" && !(rec.shared_with || []).includes(u.id)))).catch(() => {}); }, [open, rec.shared_with]);
  const toggle = (id) => setPick(p => (p.includes(id) ? p.filter(x => x !== id) : [...p, id]));
  const list = people.filter(u => `${u.name} ${u.email} ${u.business_name || ""}`.toLowerCase().includes(q.toLowerCase()));
  const send = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/api/recordings/${rec.id}/share`, { user_ids: pick, note, origin_url: window.location.origin }); toast.success(data.message); setOpen(false); setPick([]); setNote(""); onDone(); }
    catch (e) { toast.error(e.response?.data?.detail || "Couldn't share"); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild><button className="inline-flex items-center gap-1 text-sm font-bold bg-blue-600 hover:bg-blue-500 text-white px-3 py-1.5 rounded-lg" data-testid={`recording-share-${rec.id}`}><Send className="w-4 h-4" />Send to customer</button></DialogTrigger>
      <DialogContent className="bg-white max-w-md">
        <DialogHeader><DialogTitle>Send “{rec.title}”</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-500 -mt-2">They'll get an email and an inbox message, and can watch or download it from their portal.</p>
        <Input placeholder="Search customers" value={q} onChange={e => setQ(e.target.value)} data-testid="share-search-input" />
        <div className="max-h-56 overflow-y-auto border border-slate-200 rounded-lg divide-y divide-slate-100" data-testid="share-customer-list">
          {list.length === 0 && <p className="text-sm text-slate-400 p-3">No customers to show.</p>}
          {list.map(u => (
            <label key={u.id} className="flex items-center gap-2 px-3 py-2 text-sm cursor-pointer hover:bg-slate-50">
              <input type="checkbox" checked={pick.includes(u.id)} onChange={() => toggle(u.id)} data-testid={`share-pick-${u.id}`} />
              <span className="font-medium text-slate-800">{u.name}</span><span className="text-slate-400 truncate">{u.email}</span>
            </label>
          ))}
        </div>
        <Textarea placeholder="Add a note (optional)" value={note} onChange={e => setNote(e.target.value)} data-testid="share-note-input" />
        <button disabled={!pick.length || busy} onClick={send} className="w-full bg-blue-600 disabled:opacity-50 text-white font-bold py-2.5 rounded-lg flex items-center justify-center gap-2" data-testid="share-send-btn">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />}Send to {pick.length || ""} customer{pick.length === 1 ? "" : "s"}
        </button>
      </DialogContent>
    </Dialog>
  );
};
